// extracted by mini-css-extract-plugin
export var orderDetails = "_rw-2";
export var orderImage = "_rw-1";
export var orderMeta = "_rw-3";
export var orderSummary = "_rw-0";
export var rightArrow = "_rw-4";